import QueryFieldKey from '@opsbase/lib-data-queryfield/QueryFieldKey';
import generateViewFromQuery from '@opsbase/lib-data-view/helpers/generateViewFromQuery';
import Palette from '@opsbase/lib-palette';
import { enableTempStorage, getStoredValue, setStoredValue } from '@opsbase/lib-storage';
import useOpDefinitionFindById from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitionFindById';
import useOrgFindById from '@opsbase/react-gql-hooks/organisation/useOrgFindById';
import useTaskFindById from '@opsbase/react-gql-hooks/task/useTaskFindById';
import useCss from '@opsbase/web-css';
import DataTreeController from '@opsbase/web-ctrl-datatree/DataTreeController';
import useViewRegistryActions from '@opsbase/web-ctrl-view/useViewRegistryActions';
import Pane from '@opsbase/web-layout/Pane';
import useParams from '@opsbase/web-nav/useParams';
import React, { useEffect, useMemo, useState } from 'react';
import ReportCoverPage from '../ReportCoverPage';
import ViewReportChartBox from './ViewReportChartBox';
import ViewReportGroupData from './ViewReportGroupData';
const makeMyClasses = () => ({
    root: {
        backgroundColor: 'white',
        color: Palette.BlackCoral.main,
        fontFamily: 'Gilroy',
    },
});
function useKeyDecoder(uriEncodedKey) {
    return useMemo(() => {
        const key = decodeURIComponent(uriEncodedKey);
        const base64 = key.substring(key.length - 6, key.length) + key.substring(0, key.length - 6);
        const [taskId, token] = Buffer.from(base64, 'base64').toString().split('###');
        if (getStoredValue('accessToken') !== token)
            setStoredValue('accessToken', token);
        return taskId;
    }, [uriEncodedKey]);
}
export function ViewReportPage() {
    enableTempStorage();
    const { key } = useParams();
    const [state, setState] = useState();
    const { putView } = useViewRegistryActions();
    const taskId = useKeyDecoder(key);
    const { loading, data } = useTaskFindById({ variables: { id: taskId } });
    useEffect(() => {
        if (loading || !data)
            return undefined;
        if (state)
            return;
        const { title, description, orgId: organisationId, query } = data === null || data === void 0 ? void 0 : data.config;
        const view = generateViewFromQuery(query);
        putView(view);
        setState({
            organisationId,
            view,
            title,
            description,
        });
    }, [putView, loading, data, state]);
    if (!state)
        return null;
    return React.createElement(ViewReportPageInner, { ...state });
}
function ViewReportPageInner(props) {
    var _a, _b;
    const { organisationId, view, title = '', description = '' } = props;
    const myCss = useCss(makeMyClasses);
    const { loading, data: organisation } = useOrgFindById({
        variables: { id: organisationId },
    });
    const opDefFilter = view.filters.find(f => f.queryFieldKey === QueryFieldKey.OPDEFINITION);
    const skip = !opDefFilter;
    const { loading: loadingOpDefinition, data: opDefinition } = useOpDefinitionFindById({
        variables: { id: opDefFilter === null || opDefFilter === void 0 ? void 0 : opDefFilter.id },
        skip,
    });
    if (loading || !organisation)
        return null;
    if (!skip && (loadingOpDefinition || !opDefinition))
        return null;
    const chartBox = view.chartBox;
    const hasCharts = chartBox.visible && !!chartBox.charts.length;
    let subTitle = organisation === null || organisation === void 0 ? void 0 : organisation.title;
    if (!skip)
        subTitle += ' - ' + (opDefinition === null || opDefinition === void 0 ? void 0 : opDefinition.title);
    return (React.createElement(DataTreeController, { viewId: view.id, disableLazyLoading: true, hideIfEmpty: true, pageSize: 10 },
        React.createElement(Pane, { classes: { root: myCss.root } },
            React.createElement(ReportCoverPage, { title: title, subTitle: subTitle, description: description, pdf: true, pdfDetail: true, logoId: (_a = organisation.settings) === null || _a === void 0 ? void 0 : _a.logoId, titleColor: (_b = organisation.settings) === null || _b === void 0 ? void 0 : _b.titleColor }),
            hasCharts && React.createElement(ViewReportChartBox, null),
            React.createElement("div", null,
                React.createElement(ViewReportGroupData, null)))));
}
export default ViewReportPage;
